import type { Memo } from '@memori-web/shared';
import { renderMemoRow, type MemoRowCallbacks } from './memo-row.js';

export function renderMemoList(root: HTMLElement, memos: Memo[], cb: MemoRowCallbacks) {
  if (memos.length === 0) {
    root.innerHTML = `
      <div class="memo-list__empty">
        <div class="memo-list__empty-icon" aria-hidden="true">🌱</div>
        <p>最初のメモを記録しましょう</p>
        <p class="memo-list__empty-hint">下の入力欄に書くか、🎤 で話しかけてください</p>
      </div>
    `;
    return;
  }
  const visible = memos.filter(m => !m.deletedAt).sort((a, b) => b.timestamp.localeCompare(a.timestamp));
  root.innerHTML = `<div class="memo-list"></div>`;
  const list = root.querySelector<HTMLDivElement>('.memo-list')!;
  for (const m of visible) {
    const slot = document.createElement('div');
    list.appendChild(slot);
    renderMemoRow(slot, m, cb);
  }
}
